// extracted by css-extract-rspack-plugin
export default {"popoverRoot":"MenuPopover_popoverRoot__ccFji","popoverPaper":"MenuPopover_popoverPaper__uiLo7"};